import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import BrandNav from "../components/BrandNav";
import { api } from "../lib/api";
import { extractError } from "../lib/format";

export default function ForgotPassword() {
  const { t } = useTranslation("common");
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (e) {
      setErr(extractError(e, t("auth.forgot.errorFallback")));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="forgot-page">
      <BrandNav />
      <main className="ftg-shell ftg-page">
        <div className="ftg-auth">
          <h1>{t("auth.forgot.title")}</h1>
          <p className="ftg-auth__sub">{t("auth.forgot.sub")}</p>
          {sent ? (
            <div className="ftg-form" data-testid="forgot-sent">
              <div style={{ padding: 14, background: "var(--ftg-teal-mute)", borderRadius: 12, color: "var(--ftg-teal)" }}>
                {t("auth.forgot.sentBody")}
              </div>
              <Link to="/login" className="ftg-btn ftg-btn--primary ftg-btn--block" data-testid="forgot-back-login">
                {t("auth.forgot.backToLogin")}
              </Link>
            </div>
          ) : (
            <form className="ftg-form" onSubmit={submit} data-testid="forgot-form">
              <div className="ftg-field">
                <label className="ftg-field__label" htmlFor="f-email">{t("auth.email")}</label>
                <input
                  id="f-email"
                  className="ftg-field__input"
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  data-testid="forgot-email-input"
                />
              </div>
              {err ? <div className="ftg-form__error" data-testid="forgot-error">{err}</div> : null}
              <button className="ftg-btn ftg-btn--primary ftg-btn--large ftg-btn--block" disabled={busy} data-testid="forgot-submit-btn">
                {busy ? t("auth.forgot.submitBusy") : t("auth.forgot.submitIdle")}
              </button>
            </form>
          )}
        </div>
      </main>
    </div>
  );
}
